import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M45 3.7L38.5 0v2.5h-1.4c-5.2 0-10 3-12.1 7.8L22.8 15c-1.8 3.8-5.6 6.3-9.8 6.3h7.8c1.8-1.3 3.4-3.1 4.4-5.3l2.2-4.7C29 7.5 32.8 5 37.1 5h1.4v2.5L45 3.7z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M45 41.3l-6.5-3.8V40h-2.2c-3.8 0-7.2-2.2-8.8-5.6l-2.8-6c-.9-1.8-2.1-3.4-3.7-4.6h-7.4c3.8 0 7.2 2.2 8.8 5.6l2.8 6c2 4.3 6.3 7.1 11.1 7.1h2.2V45l6.5-3.7z"
	})] }), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M45 22.5l-6.5-3.7v2.5H9.1c-.6-1.8-2.3-3.2-4.4-3.2C2.1 18 0 20.2 0 22.7c0 2.6 2.1 4.7 4.7 4.7 2.2 0 4.1-1.6 4.6-3.7h29.3v2.5l6.4-3.7zM4.7 24.9c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2c-.1 1.2-1 2.2-2.2 2.2z"
	})]
});
export default SvgIcon;
